import React, { Suspense } from 'react';
import { createBrowserRouter } from 'react-router';
import { Box } from '@mui/material';
import { Root } from './Root';
import { Home } from './pages/Home';

const Services = React.lazy(() => import('./pages/Services').then((module) => ({ default: module.Services })));
const WhyItMatters = React.lazy(() => import('./pages/WhyItMatters').then((module) => ({ default: module.WhyItMatters })));
const Gallery = React.lazy(() => import('./pages/Gallery').then((module) => ({ default: module.Gallery })));
const Contact = React.lazy(() => import('./pages/Contact').then((module) => ({ default: module.Contact })));
const NotFound = React.lazy(() => import('./pages/NotFound').then((module) => ({ default: module.NotFound })));

function LazyPage({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<Box sx={{ minHeight: '100vh', background: '#080808' }} />}>
      {children}
    </Suspense>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    Component: Root,
    children: [
      { index: true, Component: Home },
      { path: 'services', element: <LazyPage><Services /></LazyPage> },
      { path: 'services/:serviceSlug', element: <LazyPage><Services /></LazyPage> },
      { path: 'why-it-matters', element: <LazyPage><WhyItMatters /></LazyPage> },
      { path: 'gallery', element: <LazyPage><Gallery /></LazyPage> },
      { path: 'contact', element: <LazyPage><Contact /></LazyPage> },
      { path: '*', element: <LazyPage><NotFound /></LazyPage> },
    ],
  },
]);
